/** @typedef {import("aerosync-web-sdk").AerosyncWidget} AerosyncWidget */
/** @typedef {import("aerosync-web-sdk").WidgetEventType} WidgetEventType */
/** @typedef {import("aerosync-web-sdk").WidgetEventSuccessType} WidgetEventSuccessType */

import clientInformation from '../login/ClientInfo';
import { RequestEWalletPayout, GetPayoutFee } from "../../services/PayoutService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Alerts from '../helpers/Alerts';
import Loading from '../helpers/Loader';
import { IsValidToken, GetCustomerInfo } from "../../services/AuthenticationService";
import { VerifyAeropayUser, LinkAeropayBank, ConfirmAeropayUser } from "../../services/DepositService";
import BeatLoader from "react-spinners/BeatLoader";
import { onlyNumbers, BonusString } from '../helpers/common';
import { isMobile } from 'react-device-detect';
import { AerosyncWidget, WidgetEventSuccessType, WidgetEventType } from "aerosync-web-sdk";
import { initAeroSyncWidget } from "aerosync-web-sdk";
import Swal from 'sweetalert2';

export const PayoutAeropayMethods = () => {
    const clientInfo = clientInformation();
    let INSTANCEID = clientInfo.InstanceID;
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    const [isProcessing, setIsProcessing] = useState(false);
    const { id } = useParams();
    const [arrayPayouts, setPayouts] = useState(JSON.parse(localStorage.getItem('arrayPayoutsMethods')).filter(function (element) { return element.PayoutID === id; })[0]);
    const navigate = useNavigate();
    const [showComponent, setshowComponent] = useState(false);
    const [OriginalAmount, setOriginalAmount] = useState(0);
    const [Fee, setFee] = useState('');
    const showCoins = sessionStorage.getItem('displaycoin') === "true";
    const [disableControl, setDisableControl] = useState(false);

    useEffect(() => {
        IsValidToken(localStorage.getItem('Token')).then(
            GetPayoutFee(localStorage.getItem('Token'), arrayPayouts?.PayoutID).then(function (response) {
                var MinFee = parseFloat(response.Authentication.MinFee);
                var PerFee = parseFloat(response.Authentication.PerFee);
                var FlatFee = parseFloat(response.Authentication.FlatFee);

                if (MinFee > 0)
                    setFee(MinFee);
                else if (PerFee > 0)
                    setFee(PerFee + "% ");
                else if (FlatFee > 0)
                    setFee(FlatFee);

                console.log(Fee);
            })
        )
            .catch(function (error) {
                navigate('/expired/');
            })

        if (arrayPayouts === undefined) {
            navigate('/payouts/');
        }

    }, [])

    /**
     * Opens the AeroSync widget and handles its lifecycle events.
     * @returns {void}
     */
    async function openAerosyncWidget(ewamount) {
        await GetCustomerInfo(localStorage.getItem('Token')).then(async function (response) {
            //Check Phone Format
            if (response.Authentication.Phone == "")
                Alerts.ShowAlert('Warning', 'Please contact support, you need to provide a valid phone', 'warning');
            else {

                var formattedPhone = response.Authentication.Phone.startsWith("1")
                    ? "+" + response.Authentication.Phone
                    : "+1" + response.Authentication.Phone;

                var email = response.Authentication.Email;
                //Validate Customer
                var formData = {
                    Token: localStorage.getItem('Token'),
                    Name: clientInfo.Name,
                    LastName: clientInfo.LastName,
                    Email: response.Authentication.Email,
                    Phone: formattedPhone /*'+18554782198'*/
                }
                await VerifyAeropayUser(formData).then(async function (response) {
                    setIsProcessing(false);
                    if (response.output.Success) {
                        if (response.output.ShowWidget) {
                            /** @type {AerosyncWidget} */
                            let widgetControls = initAeroSyncWidget({
                                elementId: "widget",
                                iframeTitle: "Connect",
                                environment: "production",
                                consumerId: "9bddc6c3-da24-4a4c-be7a-df8b55c6e695",
                                token: response.output.WidgetToken,
                                theme: "light",

                                /**
                                 * @param {WidgetEventType} event
                                 */
                                onEvent(event) {
                                    console.log("event", event);
                                },

                                onLoad() {
                                    console.log("onload");
                                },

                                /**
                                 * @param {WidgetEventSuccessType} event
                                 */
                                onSuccess(event) {
                                    console.log("onSuccess", event);
                                    var formData = {
                                        Token: localStorage.getItem('Token'),
                                        WidgetUserId: event.user_id,
                                        WidgetUserPassword: event.user_password,
                                        AeropayUserId: response.output.UserId
                                    };

                                    LinkAeropayBank(formData).then(async function (response) {
                                        if (response.output.Success) {
                                            setIsProcessing(true);
                                            await doRequestEWalletPayout(ewamount, response.output.UserId, response.output.BankId).then(async function (response) {

                                            });

                                            setIsProcessing(false);
                                            //Alerts.ShowAlert('', response.output.Message + " now the transaction will be created", 'success');

                                        }
                                        else {
                                            Alerts.ShowAlert('Warning', response.output.Message, 'warning');
                                        }
                                    });
                                },

                                onClose() {
                                    console.log("widget closed");
                                    //Alerts.ShowAlert('Warning', 'create transaction', 'warning');
                                },

                                /**
                                 * @param {string} event
                                 */
                                onError(event) {
                                    console.log("onError", event);
                                },
                            });

                            widgetControls.launch();
                        }
                        else if (response.output.ShowConfirmation) {
                            ShowConfirmation(response.output, formattedPhone, email, ewamount);
                        }
                        else {
                            if (response.output.BankId != '') {
                                if (response.output.BankList && response.output.BankList.length > 0) {
                                    const bankOptionsHtml = response.output.BankList.map((bank, index) => `
                                        <div class="form-check m-1">
                                            <input class="form-check-input" type="radio" name="selectedBank" id="bank-${index}" value="${bank.BankAccountId}" ${index === 0 ? 'checked' : ''}>
                                            <label class="form-check-label" for="bank-${index}">
                                                <strong>${bank.BankName}</strong><br/>
                                                <small>${bank.Name}</small>
                                            </label>
                                        </div>
                                    `).join('');

                                    Swal.fire({
                                        title: 'Select Bank Account',
                                        html: `
                                            <div class="text-start">
                                                ${bankOptionsHtml}
                                                <div class="mt-3 d-flex justify-content-between align-items-center">
                                                    <button id="add-new-bank-btn" class="btn btn-outline-primary btn-sm">+ Add New Bank</button>
                                                    <div>
                                                        <button id="confirm-btn" class="swal2-confirm swal2-styled">Request Redemption</button>
                                                        <button id="cancel-btn" class="btn btn-danger btn-sm ms-2">Cancel</button>
                                                    </div>
                                                </div>
                                            </div>
                                        `,
                                        showConfirmButton: false,
                                        showCancelButton: false,
                                        didOpen: () => {
                                            // Add New Bank logic
                                            document.getElementById('add-new-bank-btn')?.addEventListener('click', () => {
                                                Swal.close(); // ? Close the modal first

                                                let widgetControls = initAeroSyncWidget({
                                                    elementId: "widget",
                                                    iframeTitle: "Connect",
                                                    environment: "production",
                                                    consumerId: "9bddc6c3-da24-4a4c-be7a-df8b55c6e695",
                                                    token: response.output.WidgetToken,
                                                    theme: "light",
                                                    onEvent(event) {
                                                        console.log("event", event);
                                                    },
                                                    onLoad() {
                                                        console.log("onload");
                                                    },
                                                    onSuccess(event) {
                                                        console.log("onSuccess", event);
                                                        var formData = {
                                                            Token: localStorage.getItem('Token'),
                                                            WidgetUserId: event.user_id,
                                                            WidgetUserPassword: event.user_password,
                                                            AeropayUserId: response.output.UserId
                                                        };

                                                        LinkAeropayBank(formData).then(async function (response) {
                                                            console.log(response);
                                                            if (response.output.Success) {
                                                                /*setIsProcessing(true);
                                                                await doEWalletDeposit(ewamount, response.output.UserId, response.output.BankId);
                                                                setIsProcessing(false);*/
                                                                setDisableControl(false);
                                                                Alerts.ShowAlert('Success', response.output.Message, 'success');

                                                            } else {
                                                                Alerts.ShowAlert('Warning', response.output.Message, 'warning');
                                                            }
                                                        });
                                                    },
                                                    onClose() {
                                                        console.log("widget closed");
                                                    },
                                                    onError(event) {
                                                        console.log("onError", event);
                                                    },
                                                });

                                                widgetControls.launch();
                                            });

                                            // Confirm button logic
                                            document.getElementById('confirm-btn')?.addEventListener('click', async () => {
                                                const selectedBankId = document.querySelector('input[name="selectedBank"]:checked')?.value;
                                                if (!selectedBankId) {
                                                    Swal.showValidationMessage('Please select a bank');
                                                    return;
                                                }
                                                Swal.close();
                                                setIsProcessing(true);
                                                await doRequestEWalletPayout(ewamount, response.output.UserId, selectedBankId);
                                                setIsProcessing(false);
                                            });

                                            // Cancel button logic
                                            document.getElementById('cancel-btn')?.addEventListener('click', () => {
                                                Swal.close();
                                            });
                                        }
                                    });


                                } else {
                                    Alerts.ShowAlert('Warning', response.output.Message, 'warning');
                                }


                                //setIsProcessing(true);


                                //await doEWalletDeposit(ewamount, response.output.UserId, response.output.BankId);
                                //setIsProcessing(false);
                                //Alerts.ShowAlert('Info', 'create transaction, using bankId: ' + response.output.BankId , 'success');
                            }
                            else {
                                Alerts.ShowAlert('Warning', response.output.Message, 'warning');
                            }
                        }
                    }
                    else {
                        Alerts.ShowAlert('Warning', response.output.Message, 'warning');
                    }

                });
            }

        });
    }

    function ShowConfirmation(output, phone, email, ewamount) {
        Swal.fire({
            title: 'Verification Required ',
            html: `
            <img class="aeropay-logo" src="/svg/aeropaylarge.svg" />
            <p>${output.Message}</p>
            <input type="text" id="verification-code" class="swal2-input" placeholder="Enter verification code">
            `,
            showCancelButton: true,
            confirmButtonText: 'Verify',
            cancelButtonText: 'Cancel',
            preConfirm: () => {
                const code = document.getElementById('verification-code').value;
                if (!code) {
                    Swal.showValidationMessage('Please enter the verification code');
                    return false;
                }
                return code;
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                setIsProcessing(true);
                // Call confirmuser from Recovery controller
                var formData = {
                    Token: localStorage.getItem('Token'),
                    UserId: output.UserId,
                    MFACode: result.value,
                    Phone: phone,
                    Email: email
                }
                ConfirmAeropayUser(formData).then(async function (response) {
                    if (!response.output.Success) {
                        setIsProcessing(false);
                        Swal.fire('Error', response.output.Message || 'Verification failed', 'error');
                    }
                    else {
                        await doRequestEWalletPayout(ewamount, response.output.UserId, response.output.BankId);
                        setIsProcessing(false);
                    }
                });
            }
        });
    }

    async function doRequestEWalletPayout(Amount, UserId, BankId, comments) {
        if (parseFloat(Amount.replace(",", "").replace(" ", "")) <= parseFloat(clientInfo.WithdrawalBalance.replace(",", "")) && parseFloat(Amount.replace(",", "").replace(" ", "")) > 0) {
            var PayoutData = {
                "Token": localStorage.getItem('Token'),
                "Amount": Amount.replace(",", ""),
                "CurrencyCode": clientInfo.CurrencyCode,
                "ProcessorName": arrayPayouts?.PayoutID,
                "EWalletID": "" ,
                "SecureID": UserId + "|" + BankId,
                "IPv4Address": clientInfo.IPAddress,
                "Comments": comments,
                "Udf1": clientInfo.Udf1
            };

            await RequestEWalletPayout(PayoutData).then(function (response) {

                if (response.Authentication.ErrorCode === "") {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen('Redemption Status', response.Authentication.HtmlResponse, 'info');
                    else
                        Alerts.ShowAlert('Redemption Status', response.Authentication.HtmlResponse, 'info');
                    navigate('/payouts/');
                } else {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen('Redemption Status', response.Authentication.HtmlResponse, 'warning');
                    else
                        Alerts.ShowAlert('Redemption Status', response.Authentication.HtmlResponse, 'warning');
                }
            })
                .catch(function (error) {
                    Alerts.ShowAlert('Redemption Status', error.response.data.Authentication.HtmlResponse, 'error');
                    //Alerts.ShowAlert('Error', 'Error making deposit', 'error');
                })
        }
        else {
            if (isMobile)
                Alerts.ShowAlertFullScreen('Redemption Status', 'amount not permitted, please check your redemption balance', 'warning');
            else
                Alerts.ShowAlert('Redemption Status', 'amount not permitted, please check your redemption balance', 'warning');
        }

    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!isProcessing) {
            var data = new FormData(event.target);
            let { amount } = Object.fromEntries(data.entries());

            if (amount != '') {
                setIsProcessing(true);
                setOriginalAmount(amount);
                setIsProcessing(false);
                await openAerosyncWidget(amount);
            }
            else {
                Alerts.ShowAlert('Warning', 'Amount required', 'warning');
            }

        }
    }

    return (
        <div className="componentload">
            <form onSubmit={handleSubmit}>
                <div id="widget"></div>
                <div className="row m-4">
                    <span className="icon-single-left txt-primary">
                        <img style={{ width: "100px", height: "100px" }} src={"/svg/" + arrayPayouts?.ImageName + ".svg"} />  <span className="payout-title">Withdraw using {arrayPayouts?.PayoutID} </span>
                    </span>
                </div>
                <div className="row">
                    <div className="col-md-12 m-2" >
                        <div className="alert alert-primary text-center" role="alert">
                            Clicking on purchase you will be required to link your bank account to the system, using our regulated aeropay solution.  In case you have already a registered bank account the system will create the transaction automatically.
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 m3">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-currency-cards d-none d-md-block" id="lblCurrency">
                                    <select className="form-control selectcurrency" disabled name="ccCurrency" required value={clientInfo.CurrencyCode}>
                                        <option value="" className="">Currency</option>
                                        <option value="USD">USD</option>
                                    </select>
                                </span>
                            </div>
                            <input type="number" disabled={disableControl} onKeyPress={(event) => onlyNumbers(event)} aria-label="Amount (to the nearest dollar)" className="form-control" id="amount" aria-describedby="lblCurrency" placeholder="Amount" max={arrayPayouts?.MaxPayout === 0 ? MAXLIMIT : arrayPayouts?.MaxPayout} min={arrayPayouts?.MinPayout === 0 ? 1 : arrayPayouts?.MinPayout} name="amount" required="required" />
                        </div>

                        <div className="d-flex flex-row ml-2 limit-text-center mb-4 ">
                            Redemption Limits: Minimum {arrayPayouts?.MinPayout === 0 ? 1 : arrayPayouts?.MinPayout} USD Maximum {arrayPayouts?.MaxPayout === 0 ? 'No Limit' : arrayPayouts?.MaxPayout + ' USD'}
                        </div>
                    </div>
                </div>
             
                <div className="row">
                    <div className="col-12">
                        <div className="alert alert-danger text-center" role="alert">
                            {arrayPayouts?.PayoutID} please select your registered bank account.  If you dont have one please register one after requesting the redeption {arrayPayouts?.ImageName}.
                        </div>
                    </div>
                </div>
                {Fee != '' && <div className="row">
                    <div className="col-12">
                        <div className="alert alert-warning text-center" role="alert">
                            {Fee} fee for this payout method charged by provider
                        </div>
                    </div>
                </div>}
                {Fee == '' && <div className="row">
                    <div className="col-12">
                        <div className="alert alert-warning text-center" role="alert">
                            No withdraw fee charge by provider.
                        </div>
                    </div>
                </div>}
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12 " >

                    </div>
                    <div className="col-md-12 mb-3-small mt-4 actionbuttons">
                        <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4" onClick={() => navigate('/payouts/')}>BACK</button>
                        <button type="submit" disabled={disableControl} className="btn btn-deposit btn-deposit-order mb-4 submit">{showCoins ? "REDEMPTION" : "WITHDRAWAL"}</button>
                    </div>
                </div>


            </form>
            <div>
                {isProcessing && <Loading />}
            </div>
        </div>
    );

}